import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const LocationIOS16GlyphIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M12.0002 1.6001C7.1402 1.6001 3.2002 5.5401 3.2002 10.4001C3.2002 16.1873 8.9218 18.9577 9.6386 19.6025C10.3706 20.2609 10.9754 21.7369 11.2194 22.5737C11.3378 22.9801 11.6706 23.1857 12.0002 23.1945C12.3306 23.1849 12.6626 22.9793 12.781 22.5737C13.025 21.7369 13.6298 20.2617 14.3618 19.6025C15.0786 18.9577 20.8002 16.1873 20.8002 10.4001C20.8002 5.5401 16.8602 1.6001 12.0002 1.6001ZM12.0002 12.8001C10.6746 12.8001 9.6002 11.7257 9.6002 10.4001C9.6002 9.0745 10.6746 8.0001 12.0002 8.0001C13.3258 8.0001 14.4002 9.0745 14.4002 10.4001C14.4002 11.7257 13.3258 12.8001 12.0002 12.8001Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(LocationIOS16GlyphIcon)
